import { apiRequest } from 'utils/request'

export const referenceParameters = ({ serialNumber }) =>
  apiRequest({
    uri: '/reference-parameters/search',
    method: 'POST',
    readOnly: true,
    body: {
      vehicleId: serialNumber,
    },
  })

export const referenceParametersBySupportParameter = ({
  supportParameterNumber,
}) =>
  apiRequest({
    uri: `/support-parameters/${supportParameterNumber}/reference-parameters`,
  })
